import { render, staticRenderFns } from "./MessageBar.vue?vue&type=template&id=66c1e7d0&scoped=true&"
import script from "./MessageBar.vue?vue&type=script&lang=js&"
export * from "./MessageBar.vue?vue&type=script&lang=js&"
import style0 from "./MessageBar.vue?vue&type=style&index=0&id=66c1e7d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c1e7d0",
  null
  
)

export default component.exports